import React from "react";
import { User } from "modules/auth/User";

import MenuLink from "../MenuLink";
import HeaderNavigation, { HeaderNavigationLink } from "../HeaderNavigation";
import HeaderProfile from "../HeaderProfile";

type HeaderDesktopProps = {
  hideNavigationMenu?: boolean;
  hideProfileMenu?: boolean;
  mainNavigationLinks: MenuLink[];
  onLogin: () => any;
  onLogout: () => any;
  onStateChange?: () => void;
  onPartnerChange?: () => void;
  profileMenuLinks: MenuLink[];
  selectedState?: string;
  selectedPartnerLabel?: string;
  user: User | null;
};

const HeaderDesktop: React.FunctionComponent<HeaderDesktopProps> = ({
  hideNavigationMenu,
  hideProfileMenu,
  mainNavigationLinks,
  onLogin,
  onLogout,
  onStateChange,
  onPartnerChange,
  profileMenuLinks,
  selectedState,
  selectedPartnerLabel,
  user,
}) => {
  return (
    <React.Fragment>
      {!hideNavigationMenu && (
        <HeaderNavigation>
          {mainNavigationLinks.map((link, idx) => (
            <HeaderNavigationLink key={`main_menu_${idx}`} {...link} />
          ))}
        </HeaderNavigation>
      )}
      {!hideProfileMenu && (
        <HeaderProfile
          user={user}
          onLogout={onLogout}
          onLogin={onLogin}
          onStateChange={onStateChange}
          onPartnerChange={onPartnerChange}
          profileMenuLinks={profileMenuLinks}
          selectedState={selectedState}
          selectedPartnerLabel={selectedPartnerLabel}
        />
      )}
    </React.Fragment>
  );
};

export default HeaderDesktop;
